module.exports = __webpack_public_path__ + "static/media/st_yves_pdf_icon.ee8733a9.svg";